export const EXTERNAL_DATA = {
  headline: 'Learn more about Musical Explorers!',
  link: 'https://www.carnegiehall.org/Education/Educators/Musical-Explorers/Digital',
};
